// Force cache invalidation
export const APP_VERSION = '2.0.0';
export const BUILD_DATE = '2025-08-08T03:30:00Z';
export const API_VERSION = 'v2';

// This file forces a rebuild with new hash
console.log(`[AnonLink] Version ${APP_VERSION} built at ${BUILD_DATE}`);